import React from 'react';
import Layout from 'layouts/Layout';
import PromotionList from './PromotionList';

const PromotionListLayout = ({ match }) => <Layout component={PromotionList} match={match} />;

export default PromotionListLayout;
